import moment from 'moment';
import React from 'react';
import { NoteItemDotsSC, NoteItemSC } from './note-item.styled';
import { Typography } from '@components/ui';
import Avatar from '@components/avatar';
import { useTheme } from 'styled-components';
import { ReloadDoneOutlined } from '@icon';

type TProps = {
  note: string;
  createdAt: string;
};

const NoteItem: React.FC<TProps> = ({ note, createdAt }) => {
  const theme = useTheme();

  return (
    <NoteItemSC>
      <NoteItemDotsSC>
        <Avatar size={36} isDoctor />
        <div className="dots" />
      </NoteItemDotsSC>
      <div className="note-content">
        <div className="note-content__head">
          <Typography
            display="body2"
            variant="strong"
            style={{
              color: theme.color.tint.secondary,
              marginRight: theme.spacings.text.S,
            }}
          >
            {moment(createdAt).format('DD.MM.YYYY hh:mm')}
          </Typography>
          <ReloadDoneOutlined width={24} height={24} color={theme.color.tint.tertiary} />
        </div>
        <div
          className="note-content__body"
          style={{
            padding: theme.spacings.component.S,
          }}
        >
          <Typography display="body2" variant="default">
            {note}
          </Typography>
        </div>
      </div>
    </NoteItemSC>
  );
};

export default React.memo(NoteItem);
